import { definePendoIds } from "@impero-com/ui";

const PREFIX = "control-health-dashboard";

export const CONTROL_HEALTH_PENDO = definePendoIds({
    filtersToggle: `${PREFIX}/filters/toggle`,
    period: `${PREFIX}/filters/period`,
    showInactivePrograms: `${PREFIX}/filters/show-inactive-programs`,
    showArchivedActivities: `${PREFIX}/filters/show-archived-activities`,
    addFilter: `${PREFIX}/filters/add`,
    addTags: `${PREFIX}/filters/add-tags`,
    addControlPrograms: `${PREFIX}/filters/add-control-programs`,
    addEntities: `${PREFIX}/filters/add-entities`,
    filterTags: `${PREFIX}/filters/tags`,
    filterControlPrograms: `${PREFIX}/filters/control-programs`,
    filterEntities: `${PREFIX}/filters/entities`,
    removeFilter: `${PREFIX}/filters/remove`,
    clearAll: `${PREFIX}/filters/clear-all`,
    activityCard: `${PREFIX}/activity-health/card`,
    activityCollapse: `${PREFIX}/activity-health/collapse`,
    activityTabAll: `${PREFIX}/activity-health/tab-all`,
    activityTabHighFriction: `${PREFIX}/activity-health/tab-high-friction`,
    activityTabFriction: `${PREFIX}/activity-health/tab-friction`,
    activityTabNoFriction: `${PREFIX}/activity-health/tab-no-friction`,
    pointAllHighFriction: `${PREFIX}/activity-health/point-all-high-friction`,
    pointAllFriction: `${PREFIX}/activity-health/point-all-friction`,
    pointAllNoFriction: `${PREFIX}/activity-health/point-all-no-friction`,
    pointHighFriction: `${PREFIX}/activity-health/point-high-friction`,
    pointFriction: `${PREFIX}/activity-health/point-friction`,
    pointNoFriction: `${PREFIX}/activity-health/point-no-friction`,
    frictionCard: `${PREFIX}/friction-breakdown/card`,
    frictionCollapse: `${PREFIX}/friction-breakdown/collapse`,
    frictionTabAll: `${PREFIX}/friction-breakdown/tab-all`,
    frictionTabOverdue: `${PREFIX}/friction-breakdown/tab-overdue`,
    frictionTabRejected: `${PREFIX}/friction-breakdown/tab-rejected`,
    frictionTabReopened: `${PREFIX}/friction-breakdown/tab-reopened`,
    barAllOverdue: `${PREFIX}/friction-breakdown/bar-all-overdue`,
    barAllRejected: `${PREFIX}/friction-breakdown/bar-all-rejected`,
    barAllReopened: `${PREFIX}/friction-breakdown/bar-all-reopened`,
    barOverdueInProgress: `${PREFIX}/friction-breakdown/bar-overdue-in-progress`,
    barOverdueCompleted: `${PREFIX}/friction-breakdown/bar-overdue-completed`,
    barRejectedInProgress: `${PREFIX}/friction-breakdown/bar-rejected-in-progress`,
    barRejectedCompleted: `${PREFIX}/friction-breakdown/bar-rejected-completed`,
    barReopenedInProgress: `${PREFIX}/friction-breakdown/bar-reopened-in-progress`,
    barReopenedCompleted: `${PREFIX}/friction-breakdown/bar-reopened-completed`,
    statusCard: `${PREFIX}/status-breakdown/card`,
    adjustTable: `${PREFIX}/status-breakdown/adjust-table`,
    programLink: `${PREFIX}/status-breakdown/program-link`,
    sortProgram: `${PREFIX}/status-breakdown/sort-program`,
    sortTags: `${PREFIX}/status-breakdown/sort-tags`,
    sortOngoing: `${PREFIX}/status-breakdown/sort-ongoing`,
    sortCompletionRate: `${PREFIX}/status-breakdown/sort-completion-rate`,
    sortOnTimeRate: `${PREFIX}/status-breakdown/sort-on-time-rate`,
    sortActivities: `${PREFIX}/status-breakdown/sort-activities`,
    sortUnderSevenDays: `${PREFIX}/status-breakdown/sort-overdue-under-7-days`,
    sortSevenDaysOrMore: `${PREFIX}/status-breakdown/sort-overdue-over-7-days`,
    chipCompleted: `${PREFIX}/status-breakdown/chip-completed`,
    chipTotal: `${PREFIX}/status-breakdown/chip-total`,
    chipCompletedAfterDue: `${PREFIX}/status-breakdown/chip-completed-after-due`,
    chipInProgress: `${PREFIX}/status-breakdown/chip-in-progress`,
    chipOverdue: `${PREFIX}/status-breakdown/chip-overdue`,
    chipUnderSevenDaysResponsible: `${PREFIX}/status-breakdown/chip-under-7-days-responsible`,
    chipUnderSevenDaysReviewer: `${PREFIX}/status-breakdown/chip-under-7-days-reviewer`,
    chipUnderSevenDaysSecondReviewer: `${PREFIX}/status-breakdown/chip-under-7-days-second-reviewer`,
    chipSevenDaysOrMoreResponsible: `${PREFIX}/status-breakdown/chip-over-7-days-responsible`,
    chipSevenDaysOrMoreReviewer: `${PREFIX}/status-breakdown/chip-over-7-days-reviewer`,
    chipSevenDaysOrMoreSecondReviewer: `${PREFIX}/status-breakdown/chip-over-7-days-second-reviewer`,
});

export const ACTIVITY_TAB_PENDO = {
    all: CONTROL_HEALTH_PENDO.activityTabAll,
    highFriction: CONTROL_HEALTH_PENDO.activityTabHighFriction,
    friction: CONTROL_HEALTH_PENDO.activityTabFriction,
    noFriction: CONTROL_HEALTH_PENDO.activityTabNoFriction,
};

export const ACTIVITY_POINT_PENDO = {
    all: {
        highFriction: CONTROL_HEALTH_PENDO.pointAllHighFriction,
        friction: CONTROL_HEALTH_PENDO.pointAllFriction,
        noFriction: CONTROL_HEALTH_PENDO.pointAllNoFriction,
    },
    severity: {
        highFriction: CONTROL_HEALTH_PENDO.pointHighFriction,
        friction: CONTROL_HEALTH_PENDO.pointFriction,
        noFriction: CONTROL_HEALTH_PENDO.pointNoFriction,
    },
};

export const FRICTION_TAB_PENDO = {
    all: CONTROL_HEALTH_PENDO.frictionTabAll,
    overdue: CONTROL_HEALTH_PENDO.frictionTabOverdue,
    rejected: CONTROL_HEALTH_PENDO.frictionTabRejected,
    reopened: CONTROL_HEALTH_PENDO.frictionTabReopened,
};

export const FRICTION_BAR_PENDO = {
    all: {
        overdue: CONTROL_HEALTH_PENDO.barAllOverdue,
        rejected: CONTROL_HEALTH_PENDO.barAllRejected,
        reopened: CONTROL_HEALTH_PENDO.barAllReopened,
    },
    overdue: {
        inProgress: CONTROL_HEALTH_PENDO.barOverdueInProgress,
        completed: CONTROL_HEALTH_PENDO.barOverdueCompleted,
    },
    rejected: {
        inProgress: CONTROL_HEALTH_PENDO.barRejectedInProgress,
        completed: CONTROL_HEALTH_PENDO.barRejectedCompleted,
    },
    reopened: {
        inProgress: CONTROL_HEALTH_PENDO.barReopenedInProgress,
        completed: CONTROL_HEALTH_PENDO.barReopenedCompleted,
    },
};

export const FILTER_PENDO = {
    Tags: {
        add: CONTROL_HEALTH_PENDO.addTags,
        row: CONTROL_HEALTH_PENDO.filterTags,
    },
    ControlPrograms: {
        add: CONTROL_HEALTH_PENDO.addControlPrograms,
        row: CONTROL_HEALTH_PENDO.filterControlPrograms,
    },
    Entities: {
        add: CONTROL_HEALTH_PENDO.addEntities,
        row: CONTROL_HEALTH_PENDO.filterEntities,
    },
};
